module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-view', [_c('c-page', {
    staticClass: "s-actionsheet-container"
  }, [_c('c-navbar', {
    attrs: {
      "title": "续费中心"
    }
  }), _vm._v(" "), _c('c-content', [_c('div', {
    staticClass: "header"
  }, [_c('span', {
    staticClass: "storeName"
  }, [_vm._v(_vm._s(_vm.shopName) + " "), _c('img', {
    attrs: {
      "src": require("../../assets/images/newrenew/vipwei.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "storeInfo"
  }, [_c('span', {
    staticStyle: {
      "color": "#EEAF8C"
    }
  }, [_vm._v(_vm._s(_vm.versionInfo.versionName))]), (Number(_vm.versionInfo.leftDays) >= 0) ? _c('span', [_vm._v("将于")]) : _vm._e(), (Number(_vm.versionInfo.leftDays) >= 0) ? _c('span', {
    staticStyle: {
      "color": "#EEAF8C"
    }
  }, [_vm._v(_vm._s(Number(_vm.versionInfo.leftDays) === 0 ? '今' : _vm.versionInfo.leftDays) + "天后")]) : _c('span', [_vm._v("已")]), _vm._v("到期\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "version__box"
  }, [_c('div', {
    staticClass: "layout"
  }, [_c('div', {
    staticClass: "choose__version"
  }, _vm._l((_vm.versionInfo.busItems), function(item, index) {
    return (_vm.ifShowLong(item)) ? _c('span', {
      key: index,
      staticClass: "version__item",
      on: {
        "&click": function($event) {
          _vm.chooseItems(item)
        }
      }
    }, [_c('span', {
      staticClass: "choose__top",
      class: [item.choose ? 'active' : '']
    }, [_c('span', {
      staticClass: "top__word"
    }, [_vm._v("\n                  " + _vm._s(item.display || '-') + "\n                  ")]), _vm._v(" "), _c('span', {
      staticClass: "top__price"
    }, [_c('span', {
      staticClass: "top__price-symbol"
    }, [_vm._v("￥")]), _vm._v(_vm._s(item.finalAmount) + "\n                ")]), _vm._v(" "), (Number(item.discount) !== 0) ? _c('span', {
      staticClass: "top__original"
    }, [_vm._v("￥" + _vm._s(item.originalAmount))]) : _c('span', {
      staticClass: "top__original"
    })]), _vm._v(" "), _c('span', {
      staticClass: "choose__bottom",
      class: [item.choose ? 'active__bottom' : '']
    }, [_vm._v(_vm._s(item.type === 1 ? '开启好生意' : "以后无需再付费"))]), _vm._v(" "), (Number(item.type) === 1) ? _c('img', {
      staticClass: "top__icon",
      attrs: {
        "src": require("../../assets/images/newrenew/chaozhi.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (Number(item.type) === 2) ? _c('img', {
      staticClass: "top__icon",
      attrs: {
        "src": require("../../assets/images/newrenew/shihui.png"),
        "alt": ""
      }
    }) : _vm._e()]) : _vm._e()
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "limit-box"
  })]), _vm._v(" "), _c('c-footer', [_c('div', {
    staticClass: "renewnew__btn"
  }, [_c('span', {
    staticClass: "renew__price"
  }, [_c('span', [_vm._v("仅需:"), _c('span', {
    staticClass: "price__amount",
    staticStyle: {
      "color": "#EDAC89"
    }
  }, [_c('span', {
    staticClass: "price__smallsymobl"
  }, [_vm._v("￥")]), _vm._v(_vm._s(_vm.priceInfo.finalAmount))])]), _vm._v(" "), (Number(_vm.priceInfo.discount) > 0) ? _c('span', [_vm._v("已减￥" + _vm._s(_vm.priceInfo.discount))]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "renew__btn",
    on: {
      "click": function($event) {
        _vm.sureDialog = true
      }
    }
  }, [_vm._v("\n          立即续费\n        ")])])]), _vm._v(" "), _c('c-action-sheet', {
    attrs: {
      "visible": _vm.sureDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.sureDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "action-box"
  }, [_c('div', {
    staticClass: "action__header"
  }, [_vm._v("确认支付")]), _vm._v(" "), _c('div', {
    staticClass: "action__content"
  }, [_c('div', {
    staticClass: "content__all"
  }, [_c('span', {
    staticClass: "content__allinfo"
  }, [_vm._v("仅需")]), _vm._v(" "), _c('span', {
    staticClass: "content__allprice"
  }, [_c('span', {
    staticStyle: {
      "color": "#FF6A3C"
    }
  }, [_vm._v(_vm._s(_vm.priceInfo.finalAmount)), _c('span', {
    staticClass: "amount__symobl"
  }, [_vm._v("元")])]), _vm._v(" "), (Number(_vm.priceInfo.discount) > 0) ? _c('span', [_vm._v("优惠已减：" + _vm._s(_vm.priceInfo.discount) + "元")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "paytype"
  }, [_c('span', {
    staticClass: "ali",
    on: {
      "click": function($event) {
        _vm.chooseali = true;
        _vm.choosewx = false
      }
    }
  }, [_c('img', {
    staticClass: "ali-icon",
    attrs: {
      "src": require("../../assets/images/newrenew/ali.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "paytype__word"
  }, [_vm._v("支付宝支付")]), _vm._v(" "), (_vm.chooseali) ? _c('img', {
    staticClass: "choose",
    attrs: {
      "src": require("../../assets/images/newrenew/choose.png"),
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "choose",
    attrs: {
      "src": require("../../assets/images/newrenew/nochoose.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "wx",
    on: {
      "click": function($event) {
        _vm.choosewx = true;
        _vm.chooseali = false
      }
    }
  }, [_c('img', {
    staticClass: "wx-icon",
    attrs: {
      "src": require("../../assets/images/newrenew/wx.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "paytype__word"
  }, [_vm._v("微信支付")]), _vm._v(" "), (_vm.choosewx) ? _c('img', {
    staticClass: "choose",
    attrs: {
      "src": require("../../assets/images/newrenew/choose.png"),
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "choose",
    attrs: {
      "src": require("../../assets/images/newrenew/nochoose.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sureBtn",
    on: {
      "click": _vm.renewNow
    }
  }, [_vm._v("确认支付")])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12392596","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/newrenew/index.vue
// module id = 1019
// module chunks = 2